import { Card, CardBody, CardTitle, Table } from "reactstrap";
import PropTypes from "prop-types";

const AccountingTable = ({title, tableData}) => {
  return (
    <div>
      <Card style={{ boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.05)', marginBottom: '30px' }}>
        <CardBody>
          <CardTitle tag="h5">{title}</CardTitle>
          <Table className="no-wrap mt-3 align-middle" responsive borderless size="sm">
            <thead>
              <tr>
                <th>Concepto</th>
                <th>Ingreso</th>
                <th>Egreso</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {tableData.length === 0 ? (
                  <div className="text-center text-gray-500">No hay datos disponibles.</div>
                ) : (
              tableData.map((tdata, index) => (
                <tr key={`${tdata.id}-${index}`} className="border-top">
                  <td>
                    <div className="d-flex align-items-center p-0">
                      <div className="ms-3">                        
                        <span style={{fontWeight: "bold"}}>{tdata.category}</span>
                      </div>
                    </div>
                  </td>
                  <td>{tdata.income}</td>
                  <td>{tdata.outcome}</td>
                  <td>{tdata.balance}</td>
                </tr>
              )))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
};

AccountingTable.propTypes = {
  title: PropTypes.string,
  tableData: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string,
      income: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      outcome: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      balance: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ).isRequired
};

export default AccountingTable;
